import HeaderPage from "../../../../palette/HeaderPage";
import VerticalSpace from "../../../../palette/VerticalSpace";
import {FormContainer, Layout} from "../../../../palette/Palette";
import RadioGroup from 'devextreme-react/radio-group';
import {Button} from 'devextreme-react/button';
import {dataEdits} from "./ManagemetFormEdit";


function EditChoices(props) {

    const {editChoice, setEditChoice, setEdit, setVisibleGrid, dataEdit} = props

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="drivers-management-form" style={{width: '95%'}}>
                <HeaderPage icon={'fas fa-car'}text={`Editar datos de ${dataEdit?.name} ${dataEdit?.lastName}`}
                            load={true}/>
                <FormContainer>
                    <Layout row center space>
                        <RadioGroup items={dataEdits} layout="horizontal" value={editChoice}
                                    onValueChanged={(e) => setEditChoice(e.value)}/>
                        <Button icon="far fa-arrow-alt-circle-left"
                                text="Volver"
                                onClick={() => {
                                    setEdit(false)
                                    setVisibleGrid(true)
                                }}/>
                    </Layout>
                </FormContainer>
            </div>
        </>
    )
}

export default EditChoices